import { render, staticRenderFns } from "./PostType.vue?vue&type=template&id=16890f40&scoped=true"
import script from "./PostType.vue?vue&type=script&lang=ts"
export * from "./PostType.vue?vue&type=script&lang=ts"
import style0 from "./PostType.vue?vue&type=style&index=0&id=16890f40&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16890f40",
  null
  
)

export default component.exports